'use strict';

function ToFloat(str)
{
  let res = str.toString().replaceAll(/,/g, '.');
  return parseFloat(res);
}

export default ToFloat;